import { ADMIN_PATH } from '../../constants';

const adminNav = [
     {
          _tag: 'CSidebarNavItem',
          name: 'Dashboard',
          to: ADMIN_PATH.DASHBOARD,
          icon: 'cil-speedometer',
          badge: {
               color: 'info',
          },
     },
     {
          _tag: 'CSidebarNavItem',
          id: 'accounts',
          name: 'Accounts',
          to: ADMIN_PATH.ACCOUNTS,
          icon: 'cil-people',
          exact: false,
     },
     {
          _tag: 'CSidebarNavItem',
          name: 'Centralized Person',
          to: ADMIN_PATH.CENTRALIZED_PERSON,
          icon: 'cil-browser',
          exact: false,
     },
     {
          _tag: 'CSidebarNavItem',
          name: 'Centralized Company',
          to: ADMIN_PATH.CENTRALIZED_COMPANY,
          icon: 'cil-browser',
          exact: false,
     },
     {
          _tag: 'CSidebarNavItem',
          name: 'Split Person',
          to: ADMIN_PATH.SPLIT_PERSON,
          icon: 'cil-people',
          exact: false,
     },
     {
          _tag: 'CSidebarNavItem',
          id: 'Metrics',
          name: 'Contract Plans',
          to: ADMIN_PATH.CONTRACT_PLANS,
          icon: 'cil-layers',
          exact: false,
     },
     {
          _tag: 'CSidebarNavDropdown',
          name: 'Masterclass',
          route: '/master-class',
          icon: 'cil-school',
          _children: [
               {
                    _tag: 'CSidebarNavItem',
                    name: 'Courses',
                    to: '/courses',
                    exact: false,
               },
               {
                    _tag: 'CSidebarNavItem',
                    name: 'Lessons',
                    to: '/lessons',
                    exact: false,
               },
               {
                    _tag: 'CSidebarNavItem',
                    name: 'Tests',
                    to: '/tests',
                    exact: false,
               },
               {
                    _tag: 'CSidebarNavItem',
                    name: 'Certificates',
                    to: '/certificates',
                    exact: false,
               },
               {
                    _tag: 'CSidebarNavItem',
                    name: 'Coupons',
                    to: '/coupons',
                    exact: false,
               },
               {
                    _tag: 'CSidebarNavItem',
                    id: 'partners',
                    name: 'Partners',
                    to: ADMIN_PATH.PARTNERS,
                    exact: false,
               },
               {
                    _tag: 'CSidebarNavItem',
                    name: 'Office Hour',
                    to: ADMIN_PATH.OFFICE_HOUR,
                    exact: false,
               },
               {
                    _tag: 'CSidebarNavItem',
                    name: 'Users Course',
                    to: ADMIN_PATH.USER_COURSE,
                    exact: false,
               },
          ],
     },
     {
          _tag: 'CSidebarNavDropdown',
          name: 'System Manager',
          route: '/system-manager',
          icon: 'cil-list',
          _children: [
               {
                    _tag: 'CSidebarNavItem',
                    id: 'packages',
                    name: 'Packages',
                    to: ADMIN_PATH.PACKAGES,
                    exact: false,
               },
               {
                    _tag: 'CSidebarNavItem',
                    id: 'listeners',
                    name: 'Listeners',
                    to: ADMIN_PATH.LISTENERS,
                    exact: false,
               },
               {
                    _tag: 'CSidebarNavItem',
                    id: 'features',
                    name: 'Features',
                    to: ADMIN_PATH.FEATURES,
                    exact: false,
               },
               {
                    _tag: 'CSidebarNavItem',
                    id: 'notifications',
                    name: 'Notifications',
                    to: ADMIN_PATH.NOTIFICATIONS,
                    exact: false,
               },
               {
                    _tag: 'CSidebarNavItem',
                    id: 'notice-action',
                    name: 'Notice And Action',
                    to: ADMIN_PATH.NOTICE_ACTION,
                    exact: false,
               },
               {
                    _tag: 'CSidebarNavItem',
                    id: 'destinations',
                    name: 'Destinations',
                    to: ADMIN_PATH.DESTINATIONS,
                    exact: false,
               },
               {
                    _tag: 'CSidebarNavItem',
                    id: 'terms',
                    name: 'Terms',
                    to: ADMIN_PATH.TERMS,
                    exact: false,
               },
               {
                    _tag: 'CSidebarNavItem',
                    id: 'external-data',
                    name: 'External Data',
                    to: ADMIN_PATH.EXTERNALS,
                    exact: false,
               },
          ],
     },
     {
          _tag: 'CSidebarNavDropdown',
          name: 'Metadata',
          route: '/metadata',
          icon: 'cil-layers',
          _children: [
               {
                    _tag: 'CSidebarNavItem',
                    name: 'Activities',
                    to: ADMIN_PATH.ACTIVITIES,
                    exact: false,
               },
               {
                    _tag: 'CSidebarNavItem',
                    id: 'users',
                    name: 'Users',
                    to: ADMIN_PATH.USERS,
                    exact: false,
               },
          ],
     },
     {
          _tag: 'CSidebarNavDropdown',
          name: 'Settings',
          route: '/settings',
          icon: 'cil-settings',
          _children: [
               {
                    _tag: 'CSidebarNavItem',
                    id: 'control',
                    name: 'Control',
                    to: ADMIN_PATH.CONTROL_ADMIN,
                    exact: false,
               },
               {
                    _tag: 'CSidebarNavItem',
                    id: 'redis',
                    name: 'Redis',
                    to: ADMIN_PATH.REDIS,
                    exact: false,
               },
               {
                    _tag: 'CSidebarNavItem',
                    id: 'google-calendar',
                    name: 'Google Calendar',
                    to: ADMIN_PATH.GOOGLE_CALENDAR,
                    exact: false,
               },
               {
                    _tag: 'CSidebarNavItem',
                    id: 'media',
                    name: 'Media',
                    to: ADMIN_PATH.MEDIA,
                    exact: false,
               },
          ],
     },
     {
          _tag: 'CSidebarNavDropdown',
          name: 'Users & Sessions',
          icon: 'cil-layers',
          _children: [
               {
                    _tag: 'CSidebarNavItem',
                    name: 'Users',
                    to: '/visitors',
                    exact: false,
               },
               {
                    _tag: 'CSidebarNavItem',
                    name: 'Sessions',
                    to: '/sessions',
                    exact: false,
               },
          ],
     },
     {
          _tag: 'CSidebarNavDropdown',
          name: 'Reports',
          route: '/reports',
          icon: 'cil-signal-cellular-4',
          _children: [
               {
                    _tag: 'CSidebarNavItem',
                    id: 'custom-report',
                    name: 'Custom Report',
                    to: ADMIN_PATH.CUSTOM_REPORT,
                    exact: false,
               },
               {
                    _tag: 'CSidebarNavItem',
                    id: 'Dimensions',
                    name: 'Dimensions',
                    to: ADMIN_PATH.DIMENSIONS,
                    exact: false,
               },
               {
                    _tag: 'CSidebarNavItem',
                    id: 'Metrics',
                    name: 'Metrics',
                    to: ADMIN_PATH.METRICS,
                    exact: false,
               },
          ],
     },
     {
          _tag: 'CSidebarNavItem',
          id: 'company-matches',
          name: 'Company Matches',
          to: ADMIN_PATH.COMPANY_MATCHES,
          icon: 'cil-layers',
          exact: false,
     },
     {
          _tag: 'CSidebarNavDropdown',
          name: 'AI Insights',
          route: ADMIN_PATH.AI_INSIGHTS,
          icon: 'cil-layers',
          _children: [
               {
                    _tag: 'CSidebarNavItem',
                    name: 'Models',
                    to: ADMIN_PATH.AI_INSIGHTS_MODELS,
                    exact: false,
               },
          ],
     },
     {
          _tag: 'CSidebarNavDropdown',
          name: 'Logs',
          route: '/logs',
          icon: 'cil-notes',
          _children: [
               {
                    _tag: 'CSidebarNavItem',
                    name: 'ListenLayer SST Logs',
                    to: ADMIN_PATH.LOGS_LISTENLAYER_SST,
                    exact: false,
               },
          ],
     },
];

export default adminNav;
